/** @flow */
import customEnv from './customEnv.js'

const { protocol } = window.location

type Env = 'develop' | 'preproduction' | 'production'

type ProcessEnv = {
  NODE_ENV: Env,
  OVM: {
    API_URL: string,
    ENV?: Env,
    PORT?: number,
    SENTRY_DSN?: string,
    SENTRY_URL?: string,
    SENTRY_AUTH_TOKEN?: string,
    SENTRY_ORG?: string,
    SENTRY_PROJECT?: string,
    CI_COMMIT_TAG?: string,
    CI_COMMIT_REF_NAME?: string,
  },
}

type Settings = {
  cookieToken: 'ovm_auth',
  git: {
    CI_COMMIT_TAG?: string,
    CI_COMMIT_REF_NAME?: string,
  },
  sentry: {
    SENTRY_DSN?: string,
    SENTRY_URL?: string,
    SENTRY_AUTH_TOKEN?: string,
    SENTRY_ORG?: string,
    SENTRY_PROJECT?: string,
  },
  env: {
    API_URL: string,
    NODE_ENV: ?Env,
    PORT?: number,
  },
}

const testInstancesDomain = 'yuzu-software.com'
const { location } = window

function constructUrl(url?: ?string, subdomain?: string, port?: number, env?: string): string {
  console.log('env', env)
  if (subdomain) {
    return `${protocol}//${subdomain}${subdomain !== 'pre' ? testInstancesDomain : ''}${port ? `:${port}` : ''}/api`
  }
  if (!url) {
    return ''
  }
  return `${protocol}//${url}${port && env !== 'development' ? `:${port}` : ''}/api`
}

function constructWSUrl(apiUrl?: string, subdomain?: string, port?: number, env?: string) {
  if (subdomain) {
    return `wss://${subdomain}${subdomain !== 'pre' ? testInstancesDomain : ''}${port ? `:${port}` : ''}/api/ws`
  }
  return `${env === 'development' ? 'ws' : 'wss'}://${apiUrl}/api/ws/`
}

const processEnv: Object | ProcessEnv = process.env

const { NODE_ENV, OVM } = processEnv

const {
  API_URL,
  ENV,
  PORT,
  SENTRY_DSN,
  SENTRY_URL,
  SENTRY_AUTH_TOKEN,
  SENTRY_ORG,
  SENTRY_PROJECT,
  CI_COMMIT_TAG,
  CI_COMMIT_REF_NAME,
} = { ...OVM, ...customEnv }

const env: Env = ENV || NODE_ENV

// if (NODE_ENV !== 'test' && !API_URL) throw new Error('API_URL should be setted up.')

const getURLSubdomain = () => {
  const URLSubdomain = location.host.split('.')[0]

  // jest sets NODE_ENV to 'test' natively (see https://jestjs.io/docs/environment-variables)
  if (URLSubdomain === 'ovm' || ['development', 'preproduction', 'test'].includes(env)) {
    return ''
  }
  return `${URLSubdomain}.`
}

const subdomain = getURLSubdomain()

const settings: Settings = Object.freeze({
  cookieToken: 'ovm_auth',
  env: {
    API_URL: constructUrl(API_URL, subdomain, location.port || PORT, env),
    WS_URL: constructWSUrl(API_URL, subdomain, location.port || PORT, env),
    NODE_ENV: env,
  },
  sentry: {
    SENTRY_DSN,
    SENTRY_URL,
    SENTRY_AUTH_TOKEN,
    SENTRY_ORG,
    SENTRY_PROJECT,
  },
  git: {
    CI_COMMIT_TAG,
    CI_COMMIT_REF_NAME,
  },
})

export const isProd = (): boolean => env === 'production'

export default settings
